import { UNLOCK_PIN } from "common-fe";

// #629 — resolve the effective PIN for a show: the per-show
// `scribeUnlockPin` set in scoreadmin-fe's Settings page (score-api's
// show-config.js), falling back to common-fe's legacy UNLOCK_PIN ("5432")
// when a show has none set. Both ScribeLock (AppShell/InitialSetup's
// PinLock) and ScribeResume call this so they always unlock with the SAME
// PIN for a given show (the approved design: one PIN per show, not a
// separate resume PIN) — replaces the old hardcoded 5432/1234 constants.
export function getScribePin(show) {
  return show?.scribeUnlockPin || UNLOCK_PIN;
}
